export function isBeforeOrSameDate(date1: Date, date2: Date): boolean {
	// Convert both dates to the start of their respective days
	const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

	// Check if date1 is before or the same as date2
	return d1 <= d2;
}
